// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDH0x4axh_N4UKI77Degp4SdCAzDxciL-Y",
  authDomain: "watchinema.firebaseapp.com",
  databaseURL: "https://watchinema.firebaseio.com",
  projectId: "watchinema",
  storageBucket: "watchinema.appspot.com",
  messagingSenderId: "848885495944",
  appId: "1:848885495944:web:fb702d411fff378b63873d",
  measurementId: "G-3YS2H615PY",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
